import IApi from 'modules/shared/domain/IApi';
import api from 'modules/shared/infrastructure/api/Api';
import BaseRepository from 'modules/shared/infrastructure/repositories/BaseRepository';
import * as URL from './urls';
import IThresholdDataRepository from './iThresholdDataRepository';
import { ThresholdListDTO } from '../dto/ThresHoldDTO';
import { ThresholdMapper } from '../mappers/thresholds.mapper';
import { DLZListDTO } from '../dto/DLZDTO';
import { DLZMapper } from '../mappers/DLZ.mapper';
import { ExternalWarehouseSaturationListDTO } from '../dto/ExternalWarehouseSaturationDTO';
import { ExternalWarehouseSaturationMapper } from '../mappers/externalWarehouseSaturation.mapper';

class ThresholdDataRepository
  extends BaseRepository
  implements IThresholdDataRepository
{
  private readonly _api: IApi;
  private readonly _apiGetThresholdData: string;
  private readonly _apiGetDLZData: string;
  private readonly _apiGetExternalWarehousesSaturation: string;
  private readonly _apiSetThresholdData: string;
  private readonly _apiSetDLZData: string;

  constructor({
    api,
    apiGetThresholdData,
    apiGetDLZData,
    apiGetExternalWarehousesSaturation,
    apiSetThresholdData,
    apiSetDLZData
  }) {
    super();
    this._api = api;
    this._apiGetThresholdData = apiGetThresholdData;
    this._apiGetDLZData = apiGetDLZData;
    this._apiGetExternalWarehousesSaturation =
      apiGetExternalWarehousesSaturation;
    this._apiSetThresholdData = apiSetThresholdData;
    this._apiSetDLZData = apiSetDLZData;
  }

  getThresholdData({
    queryParams
  }: {
    queryParams: {
      workshop_id: string;
    };
  }) {
    return this._api
      .get(`${this._apiGetThresholdData}${queryParams.workshop_id}`)
      .then((res) => {
        const response = new ThresholdListDTO(res);
        return ThresholdMapper.toDomainList(response.data);
      });
  }

  getDLZData() {
    return this._api.get(`${this._apiGetDLZData}`).then((res) => {
      const response = new DLZListDTO(res);
      return DLZMapper.toDomain(response.data);
    });
  }

  getExternalWarehousesSaturation() {
    return this._api
      .get(`${this._apiGetExternalWarehousesSaturation}`)
      .then((res) => {
        const response = new ExternalWarehouseSaturationListDTO(res);
        return ExternalWarehouseSaturationMapper.toDomainList(response.data);
      });
  }

  setThreshold(queryParams: {
    workshop_id: string;
    threshold_capacity: string;
  }) {
    return this._api.put(
      `${this._apiSetThresholdData}${this._createQueryParams(queryParams)}`
    );
  }

  setDLZ(queryParams: { dlz: number; threshold_capacity: string }) {
    return this._api.put(
      `${this._apiSetDLZData}${this._createQueryParams(queryParams)}`
    );
  }
}

export default new ThresholdDataRepository({
  api: api,
  apiGetThresholdData: URL.API_GET_THRESHOLD_DATA,
  apiGetDLZData: URL.API_GET_DLZ_DATA,
  apiGetExternalWarehousesSaturation:
    URL.API_GET_EXTERNAL_WAREHOUSES_SATURATION,
  apiSetThresholdData: URL.API_SET_THRESHOLD_DATA,
  apiSetDLZData: URL.API_SET_DLZ_DATA
});

export { ThresholdDataRepository };
